<template>
    <b-container>
        <b-row fluid="md" align-v="center">
            <b-col cols="12" v-if="respuestaSif == '00'">
                <b-row class="mh-100vh">
                    <b-col offset-md="3" md="6" class="mt-4">
                        <b-img :src="urlBaseS3 + '/header/logo-carga-hites.png'" height="80" alt="Logo Movired" class="logo mb-4"
                            center />
                    </b-col>
                    <b-col offset-md="3" md="6" class="mb-3 mt-4">
                        <b-img :src="urlBaseS3 + '/pagos/cargaok.png'" alt="Logo Movired" class="logo mb-3" height="65"
                            center />
                    </b-col>
                    <b-col offset-md="3" md="6" class="mb-3">
                        <h5 class="text-center mb-2 text-bold">¡Carga exitosa!</h5>
                        <h5 class="text-center py-4">Enviamos el comprobante de tu compra al correo electrónico</h5>
                    </b-col>
                    <b-col offset-md="3" md="6">
                        <h5 class="text-center mb-5 text-bold">Detalle de la compra</h5>
                    </b-col>
                    <b-col offset-md="3" md="6">
                        <div class="d-flex justify-content-between borde-confirmacion">
                            <div class="text-left">
                                {{
                                    productoCodigo == 35 ? 'Tarjeta bip!' :
                                    'RUT bip!QR'
                                }}
                            </div>
                            <div class="text-right text-bold">{{
                                nroTarjetaBip
                            }}</div>
                        </div>
                        <div class="d-flex justify-content-between borde-confirmacion">
                            <div class="text-left">
                                Monto cargado
                            </div>
                            <div class="text-right text-bold">
                                {{
                                    new Intl.NumberFormat('es-CL', {
                                        currency:
                                            'CLP', style:
                                            'currency'
                                    }).format(monto)
                                }}
                            </div>
                        </div>
                        <div class="d-flex justify-content-between borde-confirmacion">
                            <div class="text-left">
                                Email
                            </div>
                            <div class="text-right text-bold">
                                {{ correo }}
                            </div>
                        </div>
                        <div class="d-flex justify-content-between borde-confirmacion">
                            <div class="text-left">
                                N° transacción
                            </div>
                            <div class="text-right text-bold">
                                {{
                                    transaccionId
                                }}
                            </div>
                        </div>
                    </b-col>
                    <b-col offset-md="3" md="6" class="mt-4 text-center">
                        <b-button size="lg" variant="dark" class="text-center btn-block my-4" pill @click="redirigir">
                            Volver
                        </b-button>
                    </b-col>
                </b-row>

            </b-col>
            <b-col cols="12" v-else>
                <b-row>
                    <b-col cols="12" class="mt-4">
                        <b-img :src="urlBaseS3 + '/header/logo-carga-hites.png'" height="80" alt="Logo Movired" class="logo mb-4"
                            center />
                    </b-col>
                    <b-col cols="12">
                        <b-row class="mh-100vh">
                            <b-col offset-md="3" md="6" class="mb-3 mt-4">
                                <b-img :src="urlBaseS3 + '/pagos/cargafallida.png'" alt="Logo Movired" class="logo mb-3"
                                    height="65" center />
                            </b-col>
                            <b-col offset-md="3" md="6" class="mb-3">
                                <h5 class="text-center mb-2 text-bold">Ups, no se realizó tu carga</h5>
                                <h5 class="text-center py-4">Hubo un error en la transacción. Inténtalo nuevamente en otro
                                    momento.</h5>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col offset-md="3" md="6" class="mt-4 text-center mb-5">
                        <b-button size="lg" variant="dark" class="text-center mt-5 btn-block mb-5" pill @click="redirigir">
                            Volver
                        </b-button>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
import { BRow, BCol, BContainer, BCard, BIconCircleFill, BTableSimple, BTr, BTd, BButton, BImg } from 'bootstrap-vue';
import { mapActions, mapMutations, mapState } from 'vuex';

export default {
    props: {
        nroTarjetaBip: String,
        transaccionId: String,
        monto: Number,
        correo: String,
        respuestaSif: String,
        productoNombre: String,
        productoCodigo: String,
        miClub: String,
        status: String
    },
    components: {
        BRow,
        BCol,
        BContainer,
        BCard,
        BIconCircleFill,
        BTableSimple,
        BTr,
        BTd,
        BButton,
        BImg
    },
    computed: {
        ...mapState(["urlBaseS3"]),
        ...mapState('configuracion', ["configuracionCliente"])
    },
    name: "estado-pago-dinamico-hites",
    methods: {
        ...mapActions(["resetearDatos"]),
        ...mapMutations(["bloquearFalse"]),
        redirigir() {
            this.resetearDatos()
            window.location.replace('/hites')
        }
    },
    mounted() {

    },
};
</script>

<style scoped>
@import "~bootstrap/dist/css/bootstrap.css";

.spinner {
    width: 3rem;
    height: 3rem;

}

.spinner-label {
    color: #000;
    font-size: 18px;
    font-family: Helvetica;
}

body {
    background-color: #fff !important;
}

.b-row-100vh {
    height: 100vh;
}

.button-movired-color {
    background-color: #c30030 !important;
    border-color: #c30030 !important;
    color: #fff !important;
}


.borde-confirmacion {
    font-size: 1.125rem !important;
    font-family: Helvetica !important;
    border-bottom: 2px solid #A3A3A3;
    font-weight: 300;
    color: #000;
    padding-bottom: 5px;
    margin-bottom: 10px;
}

.btn-dark {
    background-color: #000;
    border-color: #000;
    color: white !important;
}
</style>
